module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/map-f4038c202ec42e0139bd547f9f426b88.svg";